import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'deliveryDateConversion'
})
export class DeliveryDateConversionPipe implements PipeTransform {

  transform(value: number): number {
    if (value < 10) {
      // tslint:disable-next-line:no-bitwise
      return value >> 0
    }
    // fastest way to get the int is a bitwise shift
    // tslint:disable-next-line:no-bitwise
    return value / 5 >> 0;
  }

}
